import { Skeleton } from "@mui/lab";
import { ReactElement, useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import { Collection } from "../../generated/gql/graphql";
import useCollections from "../../hooks/query/collection/use-collections";
import CollectionCard from "../../pages/collection/parts/collection-card/collection-card";
import CollectionList from "../../pages/collection/parts/collection-list/collection-list";
import CollectionListItem from "../../pages/collection/parts/collection-list/collection-list-item";
import CollectionFilter from "../../pages/collection/parts/filter/filter";
import Header from "../../pages/collection/parts/header/header";
import { CollectionsContext } from "../../providers/collections-provider";
import { ListLayout } from "../../types/list";
import { parseType } from "../../utils/graphql";

export default function YourCollections(): ReactElement {
  const [cookies] = useCookies();
  const { sorting } = useContext(CollectionsContext);
  const [collections, setCollections] = useState<Collection[]>([]);

  const { data, loading, error } = useCollections({
    orderBy: [sorting],
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    setCollections(parseType<Collection[]>("collections", data));
  }, [data]);

  if (loading) {
    return (
      <div className="w-full">
        <Header title="Your Collection" amount={0} collection={undefined} />
        <div className="grid gap-[20px] grid-cols-6 w-full">
          {Array.from({ length: 16 }).map((v) => (
            <Skeleton key={`skeleton-${v}`} className="w-full h-[400px]" />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full">
        <Header title="Your Collection" amount={0} collection={undefined} />
        <div className="grid gap-[20px] grid-cols-6 w-full">
          <h2>Opps!</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Header
        title="Your Collection"
        amount={collections?.length ?? 0}
        collection={undefined}
      />
      <CollectionFilter />
      <div className="flex gap-20 flex-wrap w-full">
        {cookies.listLayout === ListLayout.Grid ? (
          collections?.map((collection) => (
            <CollectionCard key={collection.id} collection={collection} />
          ))
        ) : (
          <CollectionList>
            {collections?.map((collection) => (
              <CollectionListItem key={collection.id} collection={collection} />
            ))}
          </CollectionList>
        )}
      </div>
    </div>
  );
}
